module.exports = __webpack_public_path__ + "img/srn.14108240.svg";